import { FeatureFlag } from './../../../../core/enums/feature-flag';
import { FeatureFlagGuard } from './../../../../core/guards/feature-flag.guard';
import { Route } from '@angular/router';
//import { CanDeactivateProjectsDetails } from './projects.guards';
import { LoanRequestsResolver, LoanRequestResolver, LoanQuoteResolver } from './loans.resolvers';
import { LoansComponent } from './loans.component';
import { LoanRequestListComponent } from './list/list.component';
import { LoanRequestDetailsComponent } from './details/details.component';
import { ContactsCategoriesResolver } from 'app/modules/contacts/contacts.resolvers';
import { ContactsResolver } from 'app/modules/projects/details/dashboard/dashboard.resolvers';
import { CanDeactivateLoanQuoteDetails } from './loans.guards';
import { LoanQuoteDetailsComponent } from './loan-quote-details/loan-quote-details.component';
import { ProjectDataResolver, ProjectsFieldDefsResolver } from 'app/modules/projects/projects.resolvers';
import { SavedViewsResolver } from 'app/core';

export const loansRoutes: Route[] = [
  {
    path: '',
    component: LoansComponent,
    resolve: {
      loanRequests: LoanRequestsResolver,
    },
    children: [
      {
        path: '',
        component: LoanRequestListComponent,
        resolve: {
          options: ProjectDataResolver,
        },
        children: [
          {
            path: ':id',
            component: LoanRequestDetailsComponent,
            resolve: {
              loanRequest: LoanRequestResolver,
              categories: ContactsCategoriesResolver,
              contacts: ContactsResolver,
              options: ProjectDataResolver,
              fieldDefs: ProjectsFieldDefsResolver,
              savedViews: SavedViewsResolver,
            },
            canActivate: [FeatureFlagGuard],
            data: { featureFlag: FeatureFlag.LOAN_QUOTES, redirectPath: 'projects' },
            children: [
              {
                path: ':loan_quote_id',
                component: LoanQuoteDetailsComponent,
                resolve: {
                  loanQuote: LoanQuoteResolver,
                  options: ProjectDataResolver,
                },
                canDeactivate: [CanDeactivateLoanQuoteDetails],
              },
            ],
          },
        ],
      },
    ],
  },
];
